module.exports = __webpack_public_path__ + "fonts/source-code-pro-v22-latin-regular.410bcda9.eot";